import { SortOrder } from 'app/area/favourite/types';
import {
  FavouriteDefinition,
  DefaultSortOrder,
  Value
} from 'app/types-shared';
import { DomainNode } from 'ui/sort-order/types';

export function mapSortOptions(options: Value[]): DomainNode[] {
  return options.map(item => ({
    value: item.v,
    description: item.d
  }));
}


export function mapSortOrder(defaultSortOrder: SortOrder[]): DefaultSortOrder[] {
  return defaultSortOrder.map(item => ({
    domainNode: {
      value: item.domainNode.v,
      description: item.domainNode.d
    },
    sortOrderType: item.sortOrderType,
    orderBySequence: item.sequence
  }));
}

type FavouriteDefinitionTransform = (definition: FavouriteDefinition) => FavouriteDefinition;

export function composeDefinitionTransforms(...definitionTransforms: FavouriteDefinitionTransform[]): FavouriteDefinitionTransform {
  return definitionTransforms.reduce(
    (previous, transform) =>
      (definition) =>
        transform
          ? transform(previous(definition))
          : previous(definition)
    , definition => definition);
}
